export default "__VITE_PUBLIC_ASSET__d6e07c07__"